module.exports = __webpack_public_path__ + "img/2-1.c84121c2.png";